import type { ReactNode } from "react";
import NotFoundPage from "@/app/404";
import { useAdministersActiveOrganization } from "@/hooks/useAdministersActiveOrganization";

export function OrganizationAdminsOnly({ children }: { children: ReactNode }) {
  return useAdministersActiveOrganization() ? <>{children}</> : <NotFoundPage />;
}
